import type {
  OnBeforeUploadContinueResult,
  OnBeforeUploadErrorResult,
  OnBeforeUploadResult,
} from 'hooks/useUpload/types';

type BeforeUploadStep = (f: File) => Promise<OnBeforeUploadResult>;

export const runBeforeUploadSteps: (
  checks: BeforeUploadStep[],
  file: File,
) => Promise<OnBeforeUploadResult> = async (checks, file) => {
  let result: OnBeforeUploadResult = { type: 'continue', file };

  for (const check of checks) {
    // eslint-disable-next-line no-await-in-loop
    result = await check(result.file);
    if (result.type === 'cancel') return result;
    if (result.type === 'error') return result;
  }

  return result;
};

const validateImageDimensions = (fsFile: File) => {
  const url = URL.createObjectURL(fsFile);
  const img = new Image();

  img.onload = (event) => {
    const element = event.target as HTMLImageElement;
    URL.revokeObjectURL(url);
    if (element.naturalHeight > 10000 || element.naturalWidth > 10000) {
      throw new Error(getText('Image dimensions must be within 10000px'));
    }
  };
  img.src = url;
  return fsFile;
};

// eslint-disable-next-line @typescript-eslint/require-await
export const checkImageDimensions: BeforeUploadStep = async (file) => {
  try {
    const validatedFile = validateImageDimensions(file);
    return {
      type: 'continue',
      file: validatedFile,
    } satisfies OnBeforeUploadContinueResult;
  } catch (resizeValidationError) {
    return {
      type: 'error',
      error:
        resizeValidationError instanceof Error
          ? resizeValidationError
          : new Error(String(resizeValidationError)),
    } satisfies OnBeforeUploadErrorResult;
  }
};
